export const CHECKING_FOR_LOGGED_IN_USER = 'CHECKING_FOR_LOGGED_IN_USER';
export const CHECKING_FOR_LOGGED_IN_USER_SUCCESS = 'CHECKING_FOR_LOGGED_IN_USER_SUCCESS';
export const CHECKING_FOR_LOGGED_IN_USER_FAILURE = 'CHECKING_FOR_LOGGED_IN_USER_FAILURE';


export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER_SUCCESS  = 'LOGOUT_USER_SUCCESS';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';


export const GET_MY_ASSIGNMENTS_SUCCESS = 'GET_MY_ASSIGNMENTS_SUCCESS';
export const POST_ASSIGNMENT_SUCCESS  = 'POST_ASSIGNMENT_SUCCESS';
export const GET_MY_UPCOMING_ASSIGNMENTS_SUCCESS = 'GET_MY_UPCOMING_ASSIGNMENTS_SUCCESS';

export const GET_MY_SUBJECTS_SUCCESS = 'GET_MY_SUBJECTS_SUCCES';
export const JOIN_SUBJECT_SUCCESS = 'JOIN_SUBJECT_SUCCESS';
export const CREATE_SUBJECT_SUCCESS = 'CREATE_SUBJECT_SUCCESS';

export const GET_MY_POSTED_ASSIGNMENTS_SUCCESS = 'GET_MY_POSTED_ASSIGNMENTS_SUCCESS';
export const GET_MY_TEACHING_SUBJECTS_SUCCESS = 'GET_MY_TEACHING_SUBJECTS_SUCCESS';


export const GET_MY_SCHEDULE_SUCCESS  = 'GET_MY_SCHEDULE_SUCCESS';
export const SCHEDULE_CLASS_SUCCESS = 'SCHEDULE_CLASS_SUCCESS';